import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import {
  IPlaceInfoLandingModel,
  NvidiaShuttleChooseStationStepFormFieldsEnum,
  yupLanding,
} from "@ryde/utils-landings";

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const useYupChooseStationLandingValidationSchema = () => {
  const { t } = useTranslation();
  const yupChooseStationLandingValidationSchema = useMemo(() => {
    const employeeNumberPath = t(
      `landing.formLabel.${NvidiaShuttleChooseStationStepFormFieldsEnum.EmployeeNumber}`,
    );
    return {
      [NvidiaShuttleChooseStationStepFormFieldsEnum.EmployeeNumber]: yupLanding
        .string()
        .required(
          t("landing.validation.required", { path: employeeNumberPath }),
        )
        .matches(
          /^[0-9]+$/,
          t("landing.validation.numberOnly", { path: employeeNumberPath }),
        ),
      [NvidiaShuttleChooseStationStepFormFieldsEnum.FirstName]: yupLanding
        .string()
        .required(),
      [NvidiaShuttleChooseStationStepFormFieldsEnum.LastName]: yupLanding
        .string()
        .required(),
      [NvidiaShuttleChooseStationStepFormFieldsEnum.PhoneMobile]: yupLanding
        .string()
        .required(),
      [NvidiaShuttleChooseStationStepFormFieldsEnum.HomeAddress]: yupLanding
        .object<IPlaceInfoLandingModel>()
        .shape({
          fullAddress: yupLanding.string().required(),
          latitude: yupLanding.number().nullable().optional(),
          longitude: yupLanding.number().nullable().optional(),
        })
        .required(),
      [NvidiaShuttleChooseStationStepFormFieldsEnum.SourceStation2Id]:
        yupLanding.number().required(),
      [NvidiaShuttleChooseStationStepFormFieldsEnum.DestinationId]: yupLanding
        .number()
        .required(),
      [NvidiaShuttleChooseStationStepFormFieldsEnum.AcceptTerms]: yupLanding
        .boolean()
        .oneOf([true], t("landing.validation.acceptTermsRequired")),
      [NvidiaShuttleChooseStationStepFormFieldsEnum.AcceptPrivacyPolicy]:
        yupLanding
          .boolean()
          .oneOf([true], t("landing.validation.acceptPrivacyPolicyRequired")),
    };
  }, [t]);

  return {
    yupChooseStationLandingValidationSchema,
  };
};
